import React from 'react';
import PropTypes from 'prop-types';

export function EmptyHolder(props) {
  const onDrop = (event) => {
    event.preventDefault();
    props.onOptionDrop(event);
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <div
      className='node-holder node-undropped'
      onDragOver={onDragOver}
      onDrop={onDrop}>
      {props.placeholder}
    </div>
  );
}

EmptyHolder.propTypes = {
  /*
   * placeholder message to show if no option is dropped
   */
  placeholder: PropTypes.string.isRequired,
  /**
   * Function involked when an option is dropped
   * on EmptyHolder
   */
  onOptionDrop: PropTypes.func.isRequired,
};

EmptyHolder.defaultProps = {
  placeholder: `+ Drag step here to add`,
};
